import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { AlertTriangle, LogOut, ArrowRight } from 'lucide-react';

const SubscriptionExpired = () => {
  const { logout, user } = useAuth();
  
  const handleLogout = async () => {
    await logout();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-red-500 opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 opacity-5 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-md w-full relative z-10">
        <div className="bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20 text-center">
          
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6 relative">
            <div className="absolute inset-0 bg-red-500 opacity-20 rounded-full animate-ping"></div>
            <AlertTriangle size={36} className="text-red-600 relative z-10" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Aboneliğiniz Sona Erdi</h1>
          <p className="text-gray-600 mb-8">
            Sistemi kullanmaya devam etmek için abonelik planınızı yenilemeniz gerekmektedir. {user?.office?.name} için mevcut kullanım süreniz doldu.
          </p>

          <div className="space-y-4">
            <button
              onClick={() => window.alert("Ödeme entegrasyonu bir sonraki fazda eklenecektir.")}
              className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 px-4 rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg"
            >
              <span>Planları İncele</span>
              <ArrowRight size={18} />
            </button>
            
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 bg-gray-100 text-gray-700 font-semibold py-3 px-4 rounded-xl hover:bg-gray-200 transition-all border border-gray-200"
            >
              <LogOut size={18} />
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>

        <div className="text-center mt-6">
          <p className="text-sm text-white/60">
            Yardıma mı ihtiyacınız var? Destek ekibiyle iletişime geçin.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
